import React, { useState } from 'react';

import { CardFace } from './CardArt';

interface Props {
    cardId: string;
    name: string;
    reversed?: boolean;
}

/**
 * The card as a picture: the Rider-Waite-Smith deck (Pamela Colman Smith, 1909, public domain), bundled in
 * `public/cards/<id>.webp` so it works offline. If a picture is missing, the drawn SVG face stands in.
 * A reversed card turns the whole picture, as a card does on the table.
 */
export const CardImage: React.FC<Props> = ({ cardId, name, reversed }) => {
    const [failed, setFailed] = useState(false);
    if (failed)
        return <CardFace cardId={cardId} name={name} reversed={reversed} />;
    return (
        <img
            src={`${process.env.PUBLIC_URL}/cards/${cardId}.webp`}
            alt={name}
            draggable={false}
            onError={() => setFailed(true)}
            style={{
                display: 'block',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 8,
                border: '1px solid rgba(212,175,106,.6)',
                boxSizing: 'border-box',
                background: '#150e24',
                transform: reversed ? 'rotate(180deg)' : undefined,
                userSelect: 'none',
            }}
        />
    );
};
